import { Trans } from "@lingui/macro";

import { USD_DECIMALS } from "config/factors";
import useV2Stats from "domain/synthetics/stats/useV2Stats";
import { useChainId } from "lib/chains";
import { formatAmountHuman } from "lib/numbers";

import type { ChainStats } from "./useDashboardChainStatsMulticall";

export function OverviewCard(_: { statsArbitrum?: ChainStats; statsAvalanche?: ChainStats }) {
  const { chainId } = useChainId();

  const v2Overview = useV2Stats(chainId);

  const totalTvl = v2Overview.totalGMLiquidity;
  const totalDailyVolume = v2Overview.dailyVolume;
  const totalOpenInterest = v2Overview.openInterest;
  const totalLongPositionSizes = v2Overview.totalLongPositionSizes;
  const totalShortPositionSizes = v2Overview.totalShortPositionSizes;
  const totalLiquidPool = v2Overview.totalGMLiquidity;

  return (
    <div className="App-card !px-24">
      <div className="grid grid-cols-2 gap-32 md:grid-cols-3">
        <OverviewRow label={<Trans>Total TVL</Trans>} value={formatAmountHuman(totalTvl, USD_DECIMALS, true, 2)} />

        {/* <OverviewRow
          label={<Trans>GLP Pool</Trans>}
          value={formatAmountHuman(totalGlpTvl, USD_DECIMALS, true, 2)}
          tooltipContent={<>
            <Trans>Total value of tokens in the GLP pools.</Trans>
            <br />
            <br />
            <StatsTooltipRow
              label="Arbitrum"
              showDollar={false}
              value={formatAmountHuman(glpTvlArbitrum, USD_DECIMALS, true, 2)}
            />
            <StatsTooltipRow
              label="Avalanche"
              showDollar={false}
              value={formatAmountHuman(glpTvlAvalanche, USD_DECIMALS, true, 2)}
            />
            <div className="my-8 h-1 bg-gray-800" />
            <StatsTooltipRow
              label="Total"
              showDollar={false}
              value={formatAmountHuman(totalGlpTvl, USD_DECIMALS, true, 2)}
            />
            <br />
            <Trans>
              This value may be higher on other websites due to the collateral of positions being included in the
              calculation.
            </Trans>
          </>}
        /> */}

        <OverviewRow
          label={<Trans>Liquid Pool</Trans>}
          value={formatAmountHuman(totalLiquidPool, USD_DECIMALS, true, 2)}
        />

        <OverviewRow
          label={<Trans>24h Volume</Trans>}
          value={formatAmountHuman(totalDailyVolume, USD_DECIMALS, true, 2)}
        />

        <OverviewRow
          label={<Trans>Open Interest</Trans>}
          value={formatAmountHuman(totalOpenInterest, USD_DECIMALS, true, 2)}
        />

        <OverviewRow
          label={<Trans>Long Positions</Trans>}
          value={formatAmountHuman(totalLongPositionSizes, USD_DECIMALS, true, 2)}
        />

        <OverviewRow
          label={<Trans>Short Positions</Trans>}
          value={formatAmountHuman(totalShortPositionSizes, USD_DECIMALS, true, 2)}
        />

        {/* <div className="App-card-row">
          <div className="label">
            <Trans>Fees for the past</Trans> {formattedDuration}
          </div>
          <div>
            <TooltipComponent
              position="bottom-end"
              className="whitespace-nowrap"
              handle={formatAmountHuman(totalEpochFeesUsd, USD_DECIMALS, true, 2)}
              content={<ChainsStatsTooltipRow entries={epochFeesEntries} subtotal={feesSubtotal} />}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
}

const OverviewRow = ({
  label,
  value,
  tooltipContent,
}: {
  label: React.ReactNode;
  value: string;
  tooltipContent?: React.ReactNode;
}) => {
  return (
    <div className="flex flex-col gap-[2.4px]">
      <div className="text-body-medium !font-medium !leading-[1.5] text-gray-lighter">{label}</div>
      <div>
        {/* <TooltipComponent
        position="bottom-end"
        className="whitespace-nowrap !font-medium text-white text-h2"
        handle={value}
        content={tooltipContent}
      /> */}
        <p className="text-h2 whitespace-nowrap !font-medium text-white">{value}</p>
      </div>
    </div>
  );
};
